module.exports = __webpack_public_path__ + "img/Angeschlagener_Raum.4885ec81.svg";